module.exports = __webpack_public_path__ + "static/media/trainingLeashIcon.349381ce.png";